export default __webpack_public_path__ + "static/media/NeueHaasUnicaW01-Light.44866f2b.ttf";